import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { MediaManagerTemplate } from 'modules/manager/domain/interfaces';
import { MatchLayoutSettings } from 'modules/manager/domain/match-layout';
import {
  createFetchTemplateForEditorReducer,
  createFetchTemplateOnlyReducer,
  createSaveTemplateReducer,
  createUpdateMatchLayoutReducer,
} from './reducers';

export interface ManagerSliceState {
  activeTemplate: MediaManagerTemplate | null;
  isLoading: boolean;
  isLoaded: boolean;
  isSaving: boolean;
  error: string | null;
}

const initialState: ManagerSliceState = {
  activeTemplate: null,
  isLoading: false,
  isLoaded: false,
  isSaving: false,
  error: null,
};

export const managerSlice = createSlice({
  name: 'manager',
  initialState,
  reducers: {
    resetEditor() {
      return initialState;
    },
    setMatchLayoutLocal(state, action: PayloadAction<MatchLayoutSettings>) {
      if (state.activeTemplate) {
        state.activeTemplate.matchLayout = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    createFetchTemplateForEditorReducer(builder);
    createFetchTemplateOnlyReducer(builder);
    createSaveTemplateReducer(builder);
    createUpdateMatchLayoutReducer(builder);
  },
});

export const { resetEditor, setMatchLayoutLocal } = managerSlice.actions;
export default managerSlice.reducer;
